import React from "react"
import SearchContainer from "@geome/shell-locator-components/lib/containers/search"
import View from "./view"

const Search = (props) => (
  <SearchContainer>{(viewProps) => <View {...viewProps} {...props} />}</SearchContainer>
)

export default Search
